<template>
  <CreditCard
    :image-url="imageUrl"
    :name="name"
    :class="'credit-card--' + name"
  />
</template>
<script>
import CreditCard from './CreditCard'
import image from '../../../../../images/icons/credit_cards/diners.gif'
export default {
  components: { CreditCard },
  data() {
    return {
      name: 'ダイナースクラブ',
      imageUrl: ''
    }
  },
  mounted() {
    this.imageUrl = image
  }
}
</script>
